import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlus, FaCheck, FaExclamationCircle } from "react-icons/fa";
import Modal from "../../../../components/Utils/ModalShow";

const CreateAccountModal = ({
  isOpen,
  onClose,
  newAccountData,
  onCodeChange,
  onNameChange,
  onCreateAccount,
  createLoading
}) => {
  const { t } = useTranslation();
  const modalFooter = (
    <>
      <button
        onClick={onClose}
        className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors"
        type="button"
      >
        {t('basePrimeForm.cancel')}
      </button>
      <button
        onClick={onCreateAccount}
        disabled={
          createLoading ||
          !newAccountData.code ||
          !newAccountData.name
        }
        className="px-4 py-2 bg-[--color-primary] text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
        type="button"
      >
        {createLoading ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
            {t('createAccountModal.creating')}
          </>
        ) : (
          <>
            <FaCheck size={14} />
            {t('createAccountModal.createAccount')}
          </>
        )}
      </button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('createAccountModal.title')}
      headerIcon={<FaPlus className="text-[--color-primary]" size={20} />}
      footer={modalFooter}
    >
      <div className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('createAccountModal.accountingCode')}
          </label>
          <input
            type="text"
            value={newAccountData.code}
            onChange={onCodeChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[--color-primary]"
            placeholder={t('createAccountModal.codeExample')}
            autoFocus
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('createAccountModal.accountName')}
          </label>
          <input
            type="text"
            value={newAccountData.name}
            onChange={onNameChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[--color-primary]"
            placeholder={t('createAccountModal.nameExample')}
          />
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
          <div className="flex">
            <FaExclamationCircle className="text-yellow-400 mt-0.5" size={16} />
            <div className="ml-3">
              <p className="text-sm text-yellow-800">
                <strong>{t('createAccountModal.confirmationRequired')}</strong>
              </p>
              <p className="text-sm text-yellow-700 mt-1">
                {t('createAccountModal.confirmationText')}{" "}
                <strong>{newAccountData.code}</strong> {t('createAccountModal.confirmationTextSuffix')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateAccountModal;